export default {"src":"/_next/static/media/plant.cc8866fd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};